import React, { Component } from 'react'
import config from '../../config'
import { Card, Jumbotron, Col, Form, Button, Table } from 'react-bootstrap';
import errores from '../../middleware/errordb';
//import funciones from '../../middleware/funciones';
import Mensajes from '../subcomponent/mensajes'
import Menu from '../menu'
import ModalConfirm from '../subcomponent/modalConfirm';

export class Descuentos extends Component {
    constructor(props) {
        super(props);

        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;
        this.state = {
            evento: 1,
            fecha: todayFormat,
            codigo: "0",
            tasa: "",
            mostrarMensaje: false,
            empresa: currentCompany,
            tipo: currentUserType,
            code_erp: "",
            mensaje: "",
            textButton: "Crear Descuento",
            listDiscount: []
        }
    }

    componentDidMount() {
        this.infoDiscount();
    }

    infoDiscount = () => {
        const empresaEdicion = this.state.empresa;
        if (empresaEdicion) {
            const datasend = {
                method: 'GET',

                headers: {
                    'Content-Type': 'application/json',
                    'empresa': this.state.empresa,
                    'tipo': this.state.tipo,
                }
            }
            fetch(config.servBackEnd + '/discount/', datasend).then(response => response.json())
                .then(data => {
                    if (data.ok) {
                        this.setState({
                            listDiscount: data.data
                        })
                    } else {
                        this.setState({ mostrarMensaje: true, mensaje: "Sin tipos creados" })
                    }
                });
        }
    }

    createLine = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({show: false});
        event.preventDefault();
        const { evento } = this.state
        const { codigo } = this.state
        const { tasa } = this.state
        const { empresa } = this.state
        const { code_erp } = this.state 

        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                ID_EMPRESA: empresa,
                TASA_PORCENTAJE: tasa,
                ERP_CODE_DESCTO: code_erp,
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
                'empresa': this.state.empresa
            }
        }
        let url = "";
        if (evento) {
            url = "/discount/create/";
        } else {
            url = "/discount/modify/"+codigo
        }
        fetch(config.servBackEnd + url, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    this.infoDiscount();
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", tasa:"", codigo:"0", code_erp:"", evento: 1, textButton: "Crear Descuento" });
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Error en Tipo de inventario: " + errores[data.code] + " " + data.message })
                }
            });
    }

    edittype = (selected) => {
        this.setState({
            codigo: selected.ID_DESCUENTOS,
            tasa: selected.TASA_PORCENTAJE,
            code_erp: selected.ERP_CODE_DESCTO,
            evento: 0,
            textButton: "Modificar Descuento"
        })
    }
    cleanForm = () => {
        this.setState({
            codigo: "0",
            tasa: "",
            code_erp: "",
            evento: 1,
            textButton: "Crear Descuento"
        })
    }

    handleClose = () => {
        this.setState({show: false});
    };

    render() {
        const { listDiscount, codigo, tasa, code_erp } = this.state;
        const edittype = this.edittype;
        const mensajeConfirm = (this.state.evento) ? '¿Está seguro que desea crear línea de inventario?' : '¿Está seguro que desea modificar la línea de inventario?';
        return (
            <div>
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm}   ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>Descuentos</h2>
                </Jumbotron>
                <div>
                    <Card className="card">
                        <Card.Body>
                            <Form className="form" onSubmit={this.createLine}>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="formGridbase">
                                        <Form.Label>CODIGO</Form.Label>
                                        <Form.Control type="text"  value={codigo} required readOnly />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formGridbase">
                                        <Form.Label>Tasa</Form.Label>
                                        <Form.Control type="number" onChange={e => this.setState({ tasa: e.target.value })} value={tasa} required />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formGridbase">
                                        <Form.Label>Codigo ERP</Form.Label>
                                        <Form.Control type="number" onChange={e => this.setState({ code_erp: e.target.value })} value={code_erp} required />
                                    </Form.Group>
                                </Form.Row>
                                {!this.state.evento && <Button className="m-3" variant="primary" onClick={this.cleanForm}>Limpiar</Button>}
                                <Button className="m-3" variant="primary" type="submit">{this.state.textButton}</Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
                <div className="tableFixHead">
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Nit</th>
                                <th>Tasa</th>
                                <th>Codigo ERP</th>
                                <th colSpan="2">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listDiscount.map(function (currentData, index) {
                                return <tr key={index + "d0"}>
                                    <td>{currentData.ID_EMPRESA}</td>
                                    <td>{currentData.TASA_PORCENTAJE + ' %'}</td>
                                    <td>{currentData.ERP_CODE_DESCTO || ''}</td>
                                    <td><Button onClick={() => edittype(currentData)} variant="outline-primary">Editar</Button></td>
                                </tr>;
                            })}
                        </tbody>
                    </Table>
                </div>
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        )
    }
}

export default Descuentos
